import PrimaryButton from "components/buttons/primary-button";
import Modal from "components/modal";
import TakedownTrackModal from "components/modal/modals/takedown-track-modal";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const TrackOptions = ({
  id,
  type,
  name
}: {
  id: string;
  type: string;
  name: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <Container>
      <PrimaryButton
        onClick={() => navigate(`/overview/edit-metadata/${id}?type=${type}`)}
        text="Edit Metadata"
        icon={
          <IconContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M11.6521 4.45507L12.3008 3.80625C13.3758 2.73125 15.1188 2.73125 16.1938 3.80625C17.2688 4.88124 17.2688 6.62415 16.1938 7.69915L15.5449 8.34796M11.6521 4.45507C11.6521 4.45507 11.7331 5.8338 12.9497 7.05033C14.1662 8.26686 15.5449 8.34796 15.5449 8.34796M11.6521 4.45507L5.68718 10.4199C5.28316 10.824 5.08116 11.0259 4.90743 11.2487C4.70249 11.5115 4.5268 11.7957 4.38344 12.0965C4.26191 12.3515 4.17158 12.6226 3.99089 13.1646L3.22527 15.4615M15.5449 8.34796L9.58008 14.3129C9.17604 14.7168 8.97409 14.9188 8.75135 15.0926C8.48858 15.2975 8.20429 15.4732 7.90349 15.6166C7.6485 15.7381 7.37747 15.8284 6.83543 16.0091L4.53855 16.7748M3.22527 15.4615L3.03811 16.023C2.9492 16.2897 3.01862 16.5837 3.21744 16.7826C3.41626 16.9814 3.71035 17.0508 3.97709 16.9619L4.53855 16.7748M3.22527 15.4615L4.53855 16.7748"
                stroke="#131313"
                stroke-width="1.225"
              />
            </svg>
          </IconContainer>
        }
        iconPosition="right"
      />
      {/* <PrimaryButton
        text="View RAted Fans Link"
        onClick={() => navigate("/share/1")}
        variant="p-fade"
        icon={
          <IconContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M11.666 10C11.666 12.7614 9.42743 15 6.66602 15C3.90459 15 1.66602 12.7614 1.66602 10C1.66602 7.23857 3.90459 5 6.66602 5"
                stroke="#FEA101"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M8.33398 10C8.33398 7.23857 10.5726 5 13.334 5C16.0954 5 18.334 7.23857 18.334 10C18.334 12.7614 16.0954 15 13.334 15"
                stroke="#FEA101"
                stroke-width="1.25"
                stroke-linecap="round"
              />
            </svg>
          </IconContainer>
        }
        iconPosition="right"
      /> */}
      <PrimaryButton
        onClick={() => setIsModalOpen(true)}
        variant="d-fade"
        icon={
          <IconContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M17.0828 5H2.91602"
                stroke="#FF3333"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M15.6936 7.0835L15.3103 12.8327C15.1628 15.0452 15.089 16.1514 14.3682 16.8257C13.6474 17.5002 12.5387 17.5002 10.3214 17.5002H9.67694C7.45956 17.5002 6.3509 17.5002 5.63005 16.8257C4.90922 16.1514 4.83547 15.0452 4.68797 12.8327L4.30469 7.0835"
                stroke="#FF3333"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M7.91602 9.1665L8.33268 13.3332"
                stroke="#FF3333"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M12.0827 9.1665L11.666 13.3332"
                stroke="#FF3333"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M5.41602 5C5.46258 5 5.48587 5 5.50697 4.99947C6.19317 4.98208 6.79853 4.54576 7.03203 3.90027C7.03922 3.88041 7.04657 3.85833 7.0613 3.81414L7.14221 3.57142C7.21127 3.36423 7.24581 3.26063 7.29161 3.17267C7.47436 2.82172 7.81247 2.57803 8.20319 2.51564C8.30112 2.5 8.41035 2.5 8.62877 2.5H11.3699C11.5883 2.5 11.6976 2.5 11.7955 2.51564C12.1863 2.57803 12.5243 2.82172 12.7071 3.17267C12.7529 3.26063 12.7874 3.36423 12.8565 3.57142L12.9374 3.81414C12.9521 3.85827 12.9595 3.88042 12.9667 3.90027C13.2002 4.54576 13.8055 4.98208 14.4918 4.99947C14.5128 5 14.5361 5 14.5827 5"
                stroke="#FF3333"
                stroke-width="1.25"
              />
            </svg>
          </IconContainer>
        }
        iconPosition="center"
      />
      <Modal closeModal={() => setIsModalOpen(false)} isActive={isModalOpen}>
        <TakedownTrackModal
          closeModal={() => setIsModalOpen(false)}
          confirm={() => {}}
          name={name}
        />
      </Modal>
    </Container>
  );
};

export default TrackOptions;

const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 0.8rem;
`;

const IconContainer = styled.div`
  width: 2rem;
  height: 2rem;
`;
